<template>
	<h3 class="schema-heading">
		{{ label }}
	</h3>
</template>

<script setup lang="ts">
defineProps<{
	label: string;
}>();
</script>

<style lang="scss">
.schema-heading {
	margin-top: 12px;
	margin-bottom: 4px;
	font-size: 16px;
}

.page-form
	> div:first-of-type
	> div:first-of-type
	> div:first-of-type
	.schema-heading {
	margin-top: 0;
}
</style>
